export default "__VITE_ASSET__036a49f8__"